<template>
    <div class="vehicle-rules-list">
        <div v-for="field in fields" :key="field.key">
            <svg-icon :name="field.iconName" />
            <span>{{ field.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VehicleRulesList',
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
    },
    computed: {
        fields() {
            return [
                {
                    key: 'minimumAge',
                    iconName: 'minimum_age',
                    text: this.$t('modals.vehicle_rules.minimum_age', { age: this.vehicle.minimumAge }),
                },
                {
                    key: 'smokingAllowed',
                    iconName: this.vehicle.smokingAllowed ? 'smoking_rooms' : 'smoke_free',
                    text: this.vehicle.smokingAllowed
                        ? this.$t('modals.vehicle_rules.smoking_allowed')
                        : this.$t('modals.vehicle_rules.smoking_not_allowed'),
                },
                {
                    key: 'childrenAllowed',
                    iconName: this.vehicle.childrenAllowed ? 'child' : 'child_crossed',
                    text: this.vehicle.childrenAllowed
                        ? this.$t('modals.vehicle_rules.children_allowed')
                        : this.$t('modals.vehicle_rules.children_not_allowed'),
                },
                {
                    key: 'petsAllowed',
                    iconName: this.vehicle.petsAllowed ? 'pets' : 'pets_crossed',
                    text: this.vehicle.petsAllowed
                        ? this.$t('modals.vehicle_rules.pets_allowed')
                        : this.$t('modals.vehicle_rules.pets_not_allowed'),
                },
                {
                    key: 'festivalsAllowed',
                    iconName: this.vehicle.festivalsAllowed ? 'festival' : 'festival_crossed',
                    text: this.vehicle.festivalsAllowed
                        ? this.$t('modals.vehicle_rules.festivals_allowed')
                        : this.$t('modals.vehicle_rules.festivals_not_allowed'),
                },
            ];
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.vehicle-rules-list {
    .svg-icon {
        width: 24px;
        height: 24px;
        min-width: 24px;
        margin-right: 8px;
    }
    div {
        display: flex;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    }
}
</style>
